import { Tenant } from '../tenant/types';

// Données mock pour les tenants
export const mockTenants: Tenant[] = [
  {
    id: 'tenant-001',
    name: 'Entreprise Alpha',
    slug: 'entreprise-alpha',
    plan: 'enterprise',
    status: 'active',
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2025-03-20T14:30:00Z',
    settings: {
      maxUsers: 50,


      branding: {
        logoUrl: '/logos/alpha.png',
        primaryColor: '#3B82F6',
        secondaryColor: '#1E40AF'
      }
    },
    features: {
      advancedThreatDetection: true,
      vulnerabilityScanning: true,
      assetDiscovery: true,
      complianceReporting: true,
      apiAccess: true,
      customIntegrations: true
    }
  },
  {
    id: 'tenant-002',
    name: 'Société Beta',
    slug: 'societe-beta',
    plan: 'standard',
    status: 'active',
    createdAt: '2024-02-10T10:15:00Z',
    updatedAt: '2025-03-18T09:45:00Z',
    settings: {
      maxUsers: 20,

    },
    features: {
      advancedThreatDetection: false,
      vulnerabilityScanning: true,
      assetDiscovery: true,
      complianceReporting: false,
      apiAccess: true,
      customIntegrations: false
    }
  },
  {
    id: 'tenant-003',
    name: 'Startup Gamma',
    slug: 'startup-gamma',
    plan: 'free',
    status: 'trial',
    createdAt: '2025-03-01T14:30:00Z',
    updatedAt: '2025-04-01T11:20:00Z',
    settings: {
      maxUsers: 5,




    },
    features: {
      advancedThreatDetection: false,
      vulnerabilityScanning: false,
      assetDiscovery: true,
      complianceReporting: false,
      apiAccess: false,
      customIntegrations: false
    }
  }
];

export default mockTenants;
